import { MemberType } from '@lucidlink/dto/validation';
export function isGuestUserAccountDetails(accountDetails) {
    return (accountDetails.type === MemberType.USER &&
        !('eAccountKey' in accountDetails) &&
        !('wrappingKey' in accountDetails));
}
export function isUserAccountDetails(accountDetails) {
    return (accountDetails.type === MemberType.USER &&
        'eAccountKey' in accountDetails &&
        'wrappingKey' in accountDetails);
}
